import styles from './style.scss';

import { h, Component } from 'preact';
import { route } from 'preact-router';
import firebase, { auth, provider } from '../../firebaseConfig';

import TopAppBar from 'preact-material-components/TopAppBar';
import Drawer from 'preact-material-components/Drawer';
import List from 'preact-material-components/List';

export default class Topbar extends Component {
	closeDrawer() {
		this.drawer.MDComponent.open = false;
	}

	clickIconDrawer = () => {
		if (this.props.selectedRoute === '/') {
			return (this.drawer.MDComponent.open = true);
		}

		return history.back();
	}

	drawerRef = drawer => (this.drawer = drawer);

	linkTo = path => () => {
		route(path);
		this.closeDrawer();
	};

	iconMenu() {
		if (this.props.selectedRoute !== '/') {
			return 'keyboard_backspace';
		}
		
		return 'menu';
	}

	login = () => {
		this.closeDrawer();

		auth.signInWithPopup(provider).then(function(result) {
			route('/', true);
		})
	}

	logout = () => {
		this.closeDrawer();
		auth.signOut().then(() => {
			route('/', true);
		})
	}

	renderProfile(user) {
		if (!user) return

		return (
			<div>
				<p class="white">
					{user.displayName} <br />
					<small class="white">{user.email}</small>
				</p>
			</div>
		)
	}

	render(props, {}) {
		return (
			<div>
				<TopAppBar className="topappbar mdc-toolbar--fixed-lastrow-only" >
					<TopAppBar.Row className={this.iconMenu() ? `pl2 pr3` : ''}>
						<TopAppBar.Section align-start>
							<TopAppBar.Icon menu onClick={this.clickIconDrawer} className="pointer">
								{this.iconMenu()}
							</TopAppBar.Icon>

							<TopAppBar.Title>Pagamentos</TopAppBar.Title>
						</TopAppBar.Section>
						
						<TopAppBar.Section align-end>
							{ props.user ? (
								<div class="flex items-center">
									<span class={`${styles.profile_image} flex circle br-100`}><img src={props.user.photoURL} /></span>
								</div>
							) : null}
						</TopAppBar.Section>
					</TopAppBar.Row>

					{ props.children ? props.children : null }
				</TopAppBar>

				<Drawer modal ref={this.drawerRef}>
					<Drawer.DrawerHeader className="mdc-theme--secondary-bg">
						<p class="white">
							Pagamentos <br />
							<small class="white">Gerencie com facilidade!</small>
						</p>

						{this.renderProfile(props.user)}
					</Drawer.DrawerHeader>

					<Drawer.DrawerContent>
						<Drawer.DrawerItem selected={props.selectedRoute === '/'} onClick={this.linkTo('/')}>
							<List.ItemGraphic>home</List.ItemGraphic>
              Home
						</Drawer.DrawerItem>
						
						<Drawer.DrawerItem selected={props.selectedRoute === '/profile'} onClick={this.linkTo('/')}>
							<List.ItemGraphic>people</List.ItemGraphic>
              Meu Perfil
						</Drawer.DrawerItem>

						<hr class="mdc-list-divider" />
						
						<Drawer.DrawerItem selected={props.selectedRoute === '/configuration'} onClick={this.linkTo('/')}>
							<List.ItemGraphic>settings</List.ItemGraphic>
              Configurações
						</Drawer.DrawerItem>

						{ props.user ? (
							<Drawer.DrawerItem onClick={this.logout}>
								<List.ItemGraphic>exit_to_app</List.ItemGraphic>
								Sair
							</Drawer.DrawerItem>
						) : (
							<Drawer.DrawerItem onClick={this.login}>
								<List.ItemGraphic>exit_to_app</List.ItemGraphic>
								Login
							</Drawer.DrawerItem>
						)}
						
					</Drawer.DrawerContent>
				</Drawer>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/topbar/index.js